import { OrderItem } from '../models/OrderItem'
import { Product } from '../models/Product'

interface ICart {
  total: number
  subtotal: number
  tax: number
  products: OrderItem[]
}

export class Cart implements ICart {
  total!: number
  subtotal!: number
  tax!: number
  products!: OrderItem[]

  constructor(params: ICart) {
    Object.assign(this, params)
  }

    public static updateTotal(cart: Cart, taxRate: number) {
      cart.subtotal = 0
      cart.products.forEach((orderItem : OrderItem) => {
        cart.subtotal = cart.subtotal + orderItem.total
      })
      cart.tax = cart.subtotal * (taxRate / 100)
      cart.total = cart.subtotal + cart.tax
    }
}
